<template>
  <div class="intent-selection">
    <main-nav />
    <cvt-left-side-bar class="marketplace-left-nav-bar intent-sidebar">
      <cvt-button :loading="false" class="back-btn" text="" icon="arrow-left" />
      <h2 class="title mt-2">{{ $t('gen_ai.intent.title') }}</h2>
      <p class="description">{{ $t('gen_ai.intent.description') }}</p>
      <div class="intents">
        <div v-for="intent in intents" :key="intent.value" class="intent">
          <cvt-custom-radio
            name="intent"
            font-size="13px"
            color="#5d62ab"
            :label="intent.label"
            :disabled="loadContent"
            @change="handleChange(intent)"
          />
        </div>
      </div>
      <cvt-button
        v-if="selectedIntent"
        :loading="false"
        class="bottom-btn"
        :text="$t('gen_ai.intent.continue_btn')"
        icon="chevron-right"
        :prepend="false"
        @click="handleLoadContent"
      />
    </cvt-left-side-bar>
    <div class="content-wrapper">
      <div v-if="loadContent" class="content">
        <h2>{{ $t('gen_ai.intent.continue_msg') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { cvtRoutes } from '../../utils/routes'
import { setSessionGenAiOnboarding } from './utils'

export default {
  name: 'IntentSelection',
  props: {
    // Your props here
  },
  data() {
    return {
      intents: [
        {
          label: 'Get More Subscription Purchases',
          value: 'get-more-subscription-purchases',
        },
        { label: 'Get More Quote Starts', value: 'get-more-quote-starts' },
        { label: 'Get More Trial Signups', value: 'get-more-trial-signups' },
        { label: 'Launch My Business', value: 'launch-my-business' },
        { label: 'Run Events or Webinars', value: 'run-events-or-webinars' },
      ],

      selectedIntent: null,
      loadContent: false,
    }
  },
  computed: {
    // Your computed properties here
  },
  methods: {
    handleChange(intent) {
      this.selectedIntent = intent
    },
    handleLoadContent() {
      this.loadContent = true
      setSessionGenAiOnboarding('intent', this.selectedIntent)
      setTimeout(() => {
        this.$router.push(cvtRoutes.genAISelectTemplate.path)
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/IntentSelection.style.scss';
</style>
